export default __webpack_public_path__ + "static/media/CentreForAccessibilityBG.b43970a9.jpg";